import { SelectArticleStatus as SelectArticleStatusComponent } from './SelectArticleStatus.component';
import { connector } from './SelectArticleStatus.connector';

export const SelectArticleStatus = connector(SelectArticleStatusComponent);
